
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.571 30.71h-7.69l-2.23-10.08a1 1 0 00-1.816-.322 1 1 0 00-.134.752l2.41 10.87a1 1 0 001 .78h.86l-1.2 5.76a1 1 0 00.77 1.18c.07.01.14.01.21 0a1 1 0 001-.79l1.29-6.17h3l1.29 6.17a1 1 0 001 .79c.07.01.14.01.21 0a1 1 0 00.77-1.18l-1.2-5.76h.55a1 1 0 00.917-1.405 1.001 1.001 0 00-1.007-.595zM44.791 24.92h-13.71a1 1 0 100 2h5.85v11.75a1 1 0 102 0V26.92h5.86a1 1 0 000-2z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50.821 14.85l3.83 26.75a3.59 3.59 0 01-.87 2.85 2.911 2.911 0 01-2.23 1.05h-33.88a3.941 3.941 0 01-3.49-2.25h-5.05a3 3 0 01-2.28-1.08 3.62 3.62 0 01-.8-2.94l3.85-24.41a.25.25 0 010-.07 1.147 1.147 0 01.17-.36c0-.006-.002-.009-.004-.011-.004-.005-.01-.011.004-.059.02-.07.08-.07.08-.07l.18-.13.16-.07a1 1 0 01.22-.05h39.11a1 1 0 011 .85zM8.037 40.262c.059.23.166.444.314.628h-.05a.999.999 0 00.81.38h4.5l-2.79-19.54-2.81 17.83a1.66 1.66 0 00.026.702zm43.995 3.16a.93.93 0 00.32-.262l-.08.04a1.59 1.59 0 00.39-1.28l-3.7-25.88h-36.95l3.64 25.48a2.18 2.18 0 002 2h33.98a.93.93 0 00.4-.098z"}})])
          )
        }
      }
    